<template>
  <fb-main-body>
<!--    <el-descriptions class="desc" :title="$t('lang.APK母包信息')" :column="3" direction="horizontal">-->
<!--      <el-descriptions-item :label="$t('lang.母包版本号')">{{ formData.apk['edition'] }}</el-descriptions-item>-->
<!--      <el-descriptions-item :label="$t('lang.文件大小')">{{ formData.apk['fileSize'] | filterSize }}</el-descriptions-item>-->
<!--      <el-descriptions-item :label="$t('lang.测试状态')">{{ formData.apk['testStatusName'] }}</el-descriptions-item>-->
<!--      <el-descriptions-item :label="$t('lang.上线状态')">{{ formData.apk['releaseStatusName'] }}</el-descriptions-item>-->
<!--      <el-descriptions-item :label="$t('lang.适配型号')">{{ formData.apk['productModel'] }}</el-descriptions-item>-->
<!--      <el-descriptions-item :label="$t('lang.更新说明')">{{ formData.apk['description'] }}-->
<!--      </el-descriptions-item>-->
<!--    </el-descriptions>-->


    <el-descriptions class="desc" :title="$t('lang.APK子包信息')" :column="3" direction="horizontal">
      <el-descriptions-item :label="$t('lang.品牌商')">{{ formData['brandOwnerName'] }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.子品牌')">{{ formData['subBrandName'] }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.APK版本号')">{{ formData['subEdition'] }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.文件大小')">{{ formData['fileSize'] | filterSize }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.测试状态')">{{ $t(`lang.${formData['testStatusName']}`) }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.上线状态')">{{ formData['releaseStatusName'] }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.创建时间')">{{ formData['createTimeStr'] }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.发布时间')">{{ formData['releaseTimeStr'] }}</el-descriptions-item>
      <el-descriptions-item :label="$t('lang.已安装设备数')">{{ formData['apkEdition'] }}</el-descriptions-item>

    </el-descriptions>

<!--    <el-descriptions class="desc" :title="$t('lang.图片资源')" :column="1" direction="horizontal">-->
<!--      <el-descriptions-item :label="$t('lang.开机logo图')" label-class-name="desc-label">-->
<!--        <el-image style="width: 100px; height: 100px" :src="formData['logo'] | filterImg(that)"/>-->
<!--      </el-descriptions-item>-->
<!--      <el-descriptions-item :label="$t('lang.开机视频')" label-class-name="desc-label">-->
<!--        <video width="350px" height="150px" controls='controls' :src="formData['video'] | filterImg(that)"></video>-->
<!--      </el-descriptions-item>-->

<!--      <el-descriptions-item :label="$t('lang.屏幕保护图')" label-class-name="desc-label">-->
<!--        <el-image v-for="img in formData['screen']" :key="img" style="width: 100px; height: 100px;margin-right: 8px" :src="img | filterImg(that)" />-->
<!--      </el-descriptions-item>-->

<!--      <el-descriptions-item :label="$t('lang.账户背景图')" label-class-name="desc-label">-->
<!--        <el-image style="width: 100px; height: 100px" :src="formData['accountBackground'] | filterImg(that)"/>-->
<!--      </el-descriptions-item>-->
<!--      <el-descriptions-item :label="$t('lang.食谱入口背景图')" label-class-name="desc-label">-->
<!--        <el-image style="width: 100px; height: 100px" :src="formData['recipeBackground'] | filterImg(that)"/>-->
<!--      </el-descriptions-item>-->
<!--      <el-descriptions-item :label="$t('lang.模式入口背景图')" label-class-name="desc-label">-->
<!--        <el-image style="width: 100px; height: 100px" :src="formData['modeBackground'] | filterImg(that)"/>-->
<!--      </el-descriptions-item>-->
<!--      <el-descriptions-item :label="$t('lang.网络食谱入口背景图')" label-class-name="desc-label">-->
<!--        <el-image style="width: 100px; height: 100px" :src="formData['networkBackground'] | filterImg(that)"/>-->
<!--      </el-descriptions-item>-->

<!--      <el-descriptions-item :label="$t('lang.模式图片')" label-class-name="desc-label">-->
<!--        <div style="width: 341px">-->
<!--          <el-table border :data="tableData">-->
<!--            <el-table-column prop="name" :label="$t('lang.模式名称')" width='80'></el-table-column>-->
<!--            <el-table-column :label="$t('lang.模式背景图')" width="130">-->
<!--              <template slot-scope="scope">-->
<!--                <el-image style="width: 100px; height: 100px" :src="scope.row.bg | filterImg(that)" v-if="scope.row.bg" />-->
<!--                <span v-else>{{$t('lang.未上传')}}</span>-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column :label="$t('lang.模式图标')" width="130">-->
<!--              <template slot-scope="scope">-->
<!--                <el-image style="width: 100px; height: 100px" :src="scope.row.icon | filterImg(that)" v-if="scope.row.icon" />-->
<!--                <span v-else>{{ $t('lang.未上传') }}</span>-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--          </el-table>-->
<!--        </div>-->
<!--      </el-descriptions-item>-->
<!--    </el-descriptions>-->

  </fb-main-body>
</template>

<script>
import {loadDict} from "../../js/common";

export default {
  name: "ApkDetail",
  components: {},
  data() {
    return {
      api: {
        detail: this.$api.subApk.detail
      },
      formData: {
        apk: {}
      },
      tableData: [],
      that: this,
    }

  },
  methods: {
    handleGetDetail() {
      let vm = this;
      this.$http.post(this.api.detail, this.$qs.stringify(this.$route.query)).then(function (resp) {
        if (resp.data.status != 200) {
          vm.$message.error(resp.data.desc);
          return;
        }
        let data = resp.data.data['subApk'];


        // 回显图片
        // vm.modelInfo = [];
        data['screen'] = [];
        data['attachmentList'].forEach(i => {
          // 系统图片
          switch (i.flag) {
            case 'start_logo':
              data['logo'] = i.fileCode;
              break;
            case 'start_video':
              data['video'] = i.fileCode;
              break;
            case 'screen_protect_image':
              data['screen'].push(i.fileCode);
              break;
            case 'account_background_image':
              data['accountBackground'] = i.fileCode;
              break;
            case 'recipe_entry_background':
              data['recipeBackground'] = i.fileCode;
              break;
            case 'mode_entry_background':
              data['modeBackground'] = i.fileCode;
              break;
            case 'network_recipe_entry_background':
              data['networkBackground'] = i.fileCode;
              break;

          }

          // 附件图片
          if (i.mode) {
            let item = vm.tableData.find(m => m.value == i.mode);
            if (item) {
              let key = i.flag == 'mode_background_image' ? 'bg' : 'icon';
              item[key] = i.fileCode;
            }
          }
        })
        console.log('table', data)
        console.log('data', vm.tableData)
        vm.formData = data;
      });
    }
  }
  ,
  async created() {

    let data = await loadDict(this, 'WORK_MODE');
    this.tableData = data.map(i => {
      i.bg = '';
      i.icon = '';
      return i;
    });
    // let vm = this;
    this.handleGetDetail();

  }
}
</script>

<style scoped>

.form-box {
  max-width: 500px;
  margin-top: 24px;
}

.desc {
  margin-bottom: 24px;
}

/deep/ .desc-label {
  width: 140px;
}


</style>
